import { FC, ReactNode } from "react"

import { Checkbox, CheckboxProps, FormControlLabel } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"

interface IProps extends Omit<CheckboxProps, "name"> {
  name: string
  label?: ReactNode
  labelPlacement?: "end" | "start" | "top" | "bottom" | undefined
}

const CheckboxField: FC<IProps> = ({
  name,
  label,
  labelPlacement,
  ...props
}) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              {...props}
              checked={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              inputRef={field.ref}
            />
          }
          label={label}
          labelPlacement={labelPlacement}
        />
      )}
    />
  )
}

export default CheckboxField
